import { ChatView } from "./ChatView";

/** The welcome route (`/chat`) — no conversation selected yet. */
export function ChatPage() {
  return <ChatView conversationId={null} />;
}
